<template>
  <div class="detail">
    <div id="demo"></div>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  name: "detail",
  data() {
    return {
      pdfh5: null,
      url: "",
    };
  },
  created() {
    this.url = this.$route.query.url;
  },
  mounted() {
    //实例化
    this.pdfh5 = new Pdfh5("#demo", {
      pdfurl: this.url,
      lazy: true,
    });

    //监听完成事件
    this.pdfh5.on("complete", function (status, msg, time) {
    });
  },
};
</script>

<style lang="scss">
// .detail {
// }
::v-deep .pinch-zoom-container {
  height: 100vh !important;
}
</style>